import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { SettingsPersonalProfileContextImport } from "../../../../provider/settings/manage_personal_profile/SettingsPersonalProfileContextProvider";

const SettingsPersonalInfoButtons = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const { profileDetail, submitDetail, allowEdit } =
    SettingsPersonalProfileContextImport();

  return (
    <>
      {profileDetail != null && (
        <div style={{ width: type === 1 ? "100%" : 420 }}>
          <ButtonSingle handleClick={() => submitDetail()}>
            {AppTranslation.text(allowEdit ? "update" : "change")}
          </ButtonSingle>
        </div>
      )}
    </>
  );
};

export default SettingsPersonalInfoButtons;
